import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    courseInfo: {
      zIndex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      position: props => props.inline ? 'relative' : 'absolute',
      bottom: 0,
      width: '100%',
      backgroundColor: 'rgba(0, 0, 0, .4)',
      color: '#ffffff',
      [theme.breakpoints.down('xs')]: {
        position: 'relative !important',
        padding: '3rem',
      },
    },
    courseNameStyles: {
      borderBottom: '1px solid #ffffff',
    },
    courseLengthParStyles: {
        margin: 0,
    },
    courseBodyStyles: {
      fontSize: '16px',
      fontWeight: 'normal',
      margin: 0,
      padding: '0 1rem',
    },
  }),
);

export default function CourseOverlay(props) {
  /*
  * "inline" = TRUE   --- indicates that we're missing the Slider and need to
  *     display this info as is
  */
  const {node, inline} = props;
  let {ttlYards, holePar, golfWidth, golfDepth, title, body} = node;
  const classes = useStyles(props);

  return (
    <Box className={classes.courseInfo} py={2}>
      {!inline && title &&
        <Typography className={classes.courseNameStyles}
                  variant='h3'>{title}</Typography>
      }
      <Typography className={classes.courseLengthParStyles}>{ttlYards ? `${ttlYards} Yards` : ''}
        {holePar && ttlYards ? `, ` : ''}{holePar ? `Par ${holePar}` : ''}</Typography>
      <Typography>Width: {golfWidth} Yards&nbsp;&nbsp;&nbsp;&nbsp;Depth: {golfDepth} Yards</Typography>
      {body?.length > 0 &&
        <Typography component={`div`} className={classes.courseBodyStyles}
                    dangerouslySetInnerHTML={{__html: body}} />
      }
    </Box>
  );
};
